/**
 * RecurrenceTypeService
 * Service for managing recurrence types
 */
import { CrudService } from '../base/CrudService';
/**
 * Service for recurrence type CRUD operations
 */
export class RecurrenceTypeService extends CrudService {
    constructor(http, config) {
        super(http, {
            servicePath: config?.servicePath ?? RecurrenceTypeService.DEFAULT_SERVICE_PATH,
            basePath: RecurrenceTypeService.BASE_PATH,
            endpoints: config?.endpoints,
        });
    }
}
RecurrenceTypeService.DEFAULT_SERVICE_PATH = 'announcements';
RecurrenceTypeService.BASE_PATH = 'api/recurrence-types';
//# sourceMappingURL=RecurrenceTypeService.js.map